import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  min-height: 360px;
  align-items: center;
  justify-content: center;
`
